import { useSelector } from 'react-redux';
import { PARAMETER_KEYS } from 'constants/parameters/parameter-keys';

export const useParameterKeys = () => {
  const parameters = useSelector(state => state.parameters);
  const useLightTheme = useSelector(state => state.session.useLightTheme);

  const hasParameter = (key, value) => {
    return parameters.some(p => p.key === key && p.value === value);
  };

  const isMPDFT = hasParameter(PARAMETER_KEYS.CUSTOMER, 'MPDFT');
  const applyLightTheme = useLightTheme && isMPDFT;

  return {
    parameters,
    hasParameter,
    isMPDFT,
    applyLightTheme,
    enableChangePenaltiesView: hasParameter(PARAMETER_KEYS.ENABLE_CHANGE_PENALTIES_VIEW, 'Sim'),
    enableProjectPenaltiesList: hasParameter(PARAMETER_KEYS.ENABLE_PROJECT_PENALTIES_LIST, 'Sim'),
    enableSemaServerActivitiesView: hasParameter(
      PARAMETER_KEYS.ENABLE_SEMA_SERVER_ACTIVITIES_VIEW,
      'Sim',
    ),
    enableSeiProjectService: hasParameter(PARAMETER_KEYS.ENABLE_SEI_PROJECT_SERVICE, 'Sim'),
    enableAuditLogView: hasParameter(PARAMETER_KEYS.ENABLE_AUDIT_LOG_VIEW, 'Sim'),
    enableSemaAndCemaAssociationRegistration: hasParameter(
      PARAMETER_KEYS.ENABLE_SEMA_AND_CEMA_ASSOCIATION_REGISTRATION,
      'Sim',
    ),
    enablePartnerAssociationRegistration: hasParameter(
      PARAMETER_KEYS.ENABLE_PARTNER_ASSOCIATION_REGISTRATION,
      'Sim',
    ),
    victimIntimation: hasParameter(PARAMETER_KEYS.ENABLE_VICTIM_INTIMATION, 'Sim'),
    disabledIntimationView: hasParameter(PARAMETER_KEYS.ENABLE_INTIMATION_VIEW, 'Não'),
    disabledProsecutorLifetime: hasParameter(PARAMETER_KEYS.ENABLE_PROSECUTOR_LIFETIME, 'Não'),
    hideLawyerData: hasParameter(PARAMETER_KEYS.HIDE_LAWYER_DATA, 'Sim'),
    showSocioEducationalLecturePenalties: hasParameter(
      PARAMETER_KEYS.DISPLAY_SOCIOEDUCATIONAL_LECTURE_PENALTIES,
      'Sim',
    ),
    inquiryDisplaySubjects: hasParameter(PARAMETER_KEYS.DISPLAY_SUBJECTS_INQUIRY, 'Sim'),
    enablePenaltyTypes: hasParameter(PARAMETER_KEYS.ENABLE_PENALTY_TYPES, 'Sim'),
    showGeneralPenalties: hasParameter(PARAMETER_KEYS.DISPLAY_GENERAL_PENALTIES, 'Sim'),
    allOriginNumbersAreNpu: hasParameter(PARAMETER_KEYS.ENABLE_ALL_ORIGIN_NUMBERS_ARE_NPU, 'Sim'),
    allowCancelAgreement: hasParameter(PARAMETER_KEYS.ENABLE_CANCEL_AGREEMENT, 'Sim'),
    enableInquiryImport: hasParameter(PARAMETER_KEYS.ENABLE_INQUIRY_IMPORT, 'Sim'),
    enableRegisterAgreementFromIntimation: hasParameter(
      PARAMETER_KEYS.ENABLE_REGISTER_AGREEMENT_FROM_INTIMATION,
      'Sim',
    ),
  };
};
